import React, { useContext } from 'react'
import {Routes as Router, Route,Navigate, Outlet} from 'react-router-dom';
import { UserContext } from '../context/UserContext';
//import Navbar from "../Components/Navbar";
import Home from '../views/Home';
import Entrada from "../views/Entrada";
import Novaentrada from "../views/Novaentrada";
import Clientes from "../Components/Clientes";
import Login from "../Components/Login";
import Veiculo from "../Components/Veiculo"
import Configuracoes from '../Components/Configuracao';
import Editarentrada from '../views/Editarentrada';
import Camera from '../Components/Camera/';
import Visualizar from '../Components/Visualizar';
import Oficina from '../views/Oficina/Mecanica';
import OficinaItens from '../views/Oficina/Mecanica/visualizar';
import IniciarMecanica from '../views/Oficina/Mecanica/iniciar';
import AlterarMecanica from '../views/Oficina/Mecanica/alterarmecanica';
import OrdemInfo from '../views/Oficina/Mecanica/ordeminfo';
import Balaceamento from '../views/Oficina/Balanceamento';
import IniciarBalanceamento from '../views/Oficina/Balanceamento/iniciar';
import AlterarBalanceamento from '../views/Oficina/Balanceamento/alterar';
import Alinhamento from '../views/Oficina/Alinhamento';
import IniciarAlinhamento from '../views/Oficina/Alinhamento/iniciar';
import AlterarAlinhamento from '../views/Oficina/Alinhamento/alterar';
import Aprovacao from '../views/AprovacaoItens';
import Itensaprovacao from '../Components/ItensAprovacao';
import Fotopecas from '../Components/ItensAprovacao/Camera';
import PainelSalaVip from '../views/Painel_Sala_vip';
import Painelconsultor from '../views/Painel_consultores';
import Painelindicadores from '../views/Painel_indicadores';
import Retorna_orcamento from '../views/Retorna_orcamento';
import Aprovacaodesconto from '../views/Aprovacaodesconto';
import Orcamento from '../Prints/Orcamento';
import Printer from '../Prints/Printer';
import Extrato from '../views/Extrato_cliente';
const PrivateRoutes = () => {
    const { user } = useContext(UserContext)
    if(!user.islogin) {
        return <Navigate to={'/'} replace />
    }
    return <Outlet />
  }
const Rotas = () => {
   // const { user } = useContext(UserContext)
    return(
            <Router>
                <Route path="/" element={<Login /> } />                
                <Route element={<PrivateRoutes />}>
                    <Route path="/Home" element={<Home /> } />
                    <Route path="/entrada" element={ <Entrada />} />
                    <Route path="/novaentrada" element={ <Novaentrada />} />
                    <Route path="/editarentrada" element={ <Editarentrada />} />
                    <Route path="/Clientes" element={ <Clientes />} />   
                    <Route path="/Veiculo" element={ <Veiculo />} />  
                    <Route path="/Configuracoes" element={ <Configuracoes />} /> 
                    <Route path="/Camera" element={ <Camera />} /> 
                    <Route path="/Visualizar" element={ <Visualizar />} /> 
                    <Route path="/Oficina" element={ <Oficina />} /> 
                    <Route path="/OficinaItens" element={ <OficinaItens />} /> 
                    <Route path="/IniciarMecanica" element={ <IniciarMecanica />} /> 
                    <Route path="/AlterarMecanica" element={ <AlterarMecanica />} /> 
                    <Route path="/OrdemInfo" element={ <OrdemInfo />} /> 
                    <Route path="/balanceamento" element={ <Balaceamento />} /> 
                    <Route path="/IniciarBalanceamento" element={ <IniciarBalanceamento />} /> 
                    <Route path="/AlterarBalanceamento" element={ <AlterarBalanceamento />} /> 
                    <Route path="/alinhamento" element={ <Alinhamento />} /> 
                    <Route path="/IniciarAlinhamento" element={ <IniciarAlinhamento />} /> 
                    <Route path="/AlterarAlinhamento" element={ <AlterarAlinhamento />} />
                    <Route path="/Itensaprovacao" element={ <Itensaprovacao />} />      
                    <Route path="/Fotopecas" element={ <Fotopecas />} />     
                    <Route path="/Retorno" element={ <Retorna_orcamento />} /> 
                    <Route path="/Aprovacaodesconto" element={ <Aprovacaodesconto />} /> 
                    <Route path="/Printer" element={ <Printer />} />   
                    <Route path="/Orcamento" element={ <Orcamento />} /> 
                    <Route path="/Extrato" element={ <Extrato />} />    
                </Route>
                <Route path="/aprovacao" element={ <Aprovacao />} /> 
                <Route path="/PainelVip" element={ <PainelSalaVip />} /> 
                <Route path="/PainelConsultor" element={ <Painelconsultor />} />
                <Route path="/PainelIndicadores" element={ <Painelindicadores />} />
            </Router>
    );
}

export default Rotas;